import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./../../authConfig";

export const Authenticate = async () => {
    const config = { 
        ...msalConfig, 
        auth: {
            ...msalConfig.auth,
            redirectUri: window.location.origin
        }
    };

    const client = new PublicClientApplication(config);
    return await client.loginPopup(loginRequest);
}